// @flow
import React, { type Node } from 'react';

import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon';
import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './ComplexDishItem.module.scss';;


type Props = {
  index: number,
  portion: string,
  title: string,
  disabledTooltips?: boolean,
}

const ComplexDishIndex = ({ title, portion, index, disabledTooltips }: Props): Node => {
  const name = `${index + 1}. ${title}`;

  return (
    <div className={styles.root}>
      <PlainTooltip
        text={!disabledTooltips ? title : null}
        className={styles.dishTitle}
        hideWithoutOverflow
      >
        {name}
      </PlainTooltip>

      {portion
        && <PlainTooltip
          text={!disabledTooltips ? portion : null}
          className={styles.dishPortion}
          hideWithoutOverflow
        >
          <PlainIcon
            type={iconTypes.PORTION}
            colorType={disabledTooltips ? colorTypes.COLOR_LIGHTGRAY : colorTypes.COLOR_DARKGRAY}
          />
          &nbsp;
          <span>{portion}</span>
        </PlainTooltip>}
    </div>
  );
};

export default ComplexDishIndex;
